module.exports = __webpack_public_path__ + "static/media/transcy-icon.c6220a4d.png";